export default "__VITE_ASSET__0fcb3f12__"